import clsx from "clsx";
import { formatHours, toHoursUsageDisplay, type HoursUsageEntry } from "@/pages/projekte/hoursUsage";

interface HoursUsageCellProps {
  entry?: HoursUsageEntry;
}

export function HoursUsageCell({ entry }: HoursUsageCellProps) {
  const display = toHoursUsageDisplay(entry);

  if (!display) {
    return <span className="text-label-tertiary">—</span>;
  }

  if (display.loading) {
    return (
      <span className="inline-flex items-center" title={display.tooltip}>
        <span
          className="eh-hours-usage-ring eh-hours-usage-ring--loading"
          aria-hidden
        />
        <span className="sr-only">{display.tooltip}</span>
      </span>
    );
  }

  const ratioLabel = `${formatHours(display.actualHours)}/${formatHours(display.plannedHours)}`;

  return (
    <span
      className={clsx(
        "eh-hours-usage-cell",
        display.trafficLight === "over" || display.isOver
          ? "eh-hours-usage-cell--over"
          : display.trafficLight === "warn"
            ? "eh-hours-usage-cell--warn"
            : "eh-hours-usage-cell--ok",
      )}
      title={display.tooltip}
    >
      <span
        className="eh-hours-usage-ring"
        style={{ "--eh-hours-p": display.ringPercent } as React.CSSProperties}
        aria-hidden
      >
        <span className="eh-hours-usage-label">{display.displayPercent}%</span>
      </span>
      <span className="sr-only">
        {display.displayPercent}% ({ratioLabel})
      </span>
    </span>
  );
}
